import { render, staticRenderFns } from "./content-exposure-objective.vue?vue&type=template&id=507fff82"
import script from "./content-exposure-objective.ts?vue&type=script&lang=ts&external"
export * from "./content-exposure-objective.ts?vue&type=script&lang=ts&external"
import style0 from "./content-exposure-objective.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports